var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadedMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.2189 60.5208C13.5201 60.5208 12.8213 60.2413 12.2623 59.6823L6.67204 54.092C5.55398 52.974 5.55398 51.2969 6.67204 50.1788C7.79009 49.0608 9.60693 49.0608 10.5852 50.1788L14.2189 53.8125L23.4429 44.5885C24.5609 43.4705 26.238 43.4705 27.3561 44.5885C28.4741 45.7066 28.4741 47.3837 27.3561 48.5017L16.1755 59.6823C15.6165 60.2413 14.9177 60.5208 14.2189 60.5208Z",
    fill: "#1DCE91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8687 52.4999C37.1182 41.0986 27.6327 32.0833 16.0415 32.0833C14.5432 32.0833 13.0801 32.2339 11.6665 32.5208V20.4166C11.6665 17.1949 14.2782 14.5833 17.4998 14.5833H58.3332C61.5548 14.5833 64.1665 17.1949 64.1665 20.4166V46.6666C64.1665 49.8882 61.5548 52.4999 58.3332 52.4999H37.8687ZM55.8377 19.9489L37.9165 29.5988L19.9953 19.9489C18.9315 19.3761 17.6049 19.7741 17.0321 20.8378C16.4594 21.9015 16.8574 23.2282 17.9211 23.801L36.8794 34.0093C37.5269 34.3579 38.3062 34.3579 38.9536 34.0093L57.9119 23.801C58.9757 23.2282 59.3736 21.9015 58.8009 20.8378C58.2281 19.7741 56.9015 19.3761 55.8377 19.9489Z",
    fill: "#1DCE91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadedMail);
export default __webpack_public_path__ + "static/media/readed-mail.306273f9d79259b057fb8fd84b0f675d.svg";
export { ForwardRef as ReactComponent };